import { render } from "./BaseMainDashboardTemplate.vue?vue&type=template&id=2988501a"
import script from "./BaseMainDashboardTemplate.vue?vue&type=script&lang=js"
export * from "./BaseMainDashboardTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseMainDashboardTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2988501a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2988501a', __exports__)) {
    api.reload('2988501a', __exports__)
  }
  
  module.hot.accept("./BaseMainDashboardTemplate.vue?vue&type=template&id=2988501a", () => {
    api.rerender('2988501a', render)
  })

}


export default __exports__